<div class="article-editor">
    <div class="editor-header">
        <h2>{{isEditMode ? 'Artikel bearbeiten' : 'Neuer Artikel'}}</h2>
    </div>

    <div class="editor-form">
        <!-- Title -->
        <div class="form-field">
            <label for="title">Titel *</label>
            <input id="title"
                   type="text"
                   pInputText
                   [(ngModel)]="title"
                   placeholder="Artikeltitel eingeben..."
                   class="w-full" />
        </div>

        <!-- Summary -->
        <div class="form-field">
            <label for="summary">Zusammenfassung</label>
            <textarea id="summary"
                      pTextarea
                      [(ngModel)]="summary"
                      placeholder="Kurze Zusammenfassung..."
                      rows="2"
                      class="w-full">
            </textarea>
        </div>

        <!-- Category -->
        <div class="form-field">
            <label for="category">Kategorie</label>
            <p-select id="category"
                      [options]="categories"
                      [(ngModel)]="selectedCategoryId"
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Kategorie waehlen..."
                      [showClear]="true"
                      styleClass="w-full">
            </p-select>
        </div>

        <!-- Content (TinyMCE) -->
        <div class="form-field">
            <label>Inhalt *</label>
            <editor [(ngModel)]="content" [init]="tinyMceConfig"></editor>
        </div>

        <!-- Sort Order -->
        <div class="form-field">
            <label for="sortOrder">Sortierung</label>
            <p-inputNumber id="sortOrder"
                           [(ngModel)]="sortOrder"
                           [min]="0">
            </p-inputNumber>
        </div>

        <!-- Tags -->
        <div class="form-field">
            <label for="tags">Tags (JSON Array)</label>
            <input id="tags"
                   type="text"
                   pInputText
                   [(ngModel)]="tagsJson"
                   placeholder='["tag1", "tag2"]'
                   class="w-full" />
        </div>

        <!-- Change Note (for edit mode) -->
        <div class="form-field" *ngIf="isEditMode">
            <label for="changeNote">Aenderungsnotiz</label>
            <input id="changeNote"
                   type="text"
                   pInputText
                   [(ngModel)]="changeNote"
                   placeholder="Was wurde geaendert?"
                   class="w-full" />
        </div>
    </div>

    <!-- Actions -->
    <div class="editor-actions">
        <button pButton
                label="Abbrechen"
                class="p-button-text"
                (click)="onCancel()">
        </button>
        <button pButton
                [label]="isEditMode ? 'Speichern' : 'Erstellen'"
                icon="pi pi-save"
                [loading]="isSaving"
                [disabled]="!title.trim() || !content.trim()"
                (click)="onSave()">
        </button>
    </div>
</div>
